<template>
  <DashboardLayout class="employee">
    <!-- Unassigned -->
    <CardsSection
      collapse
      v-if="currentUser.is_editor"
      title="Acciones sin asignar"
      class="unassigned"
      :transition-duration="500"
      :items-length="getUnassignedCards.length"
    >
      <CardsSectionBlock>
        <CardSingle v-for="card in getUnassignedCards" :key="card.id" :card="card" />
      </CardsSectionBlock>
    </CardsSection>
    <!-- Actives -->
    <CardsSection
      collapse
      title="Acciones activas"
      class="actives"
      :transition-duration="500"
      :items-length="filteredCards(['active']).length"
    >
      <CardsSectionBlock>
        <CardSingle v-for="card in filteredCards(['active'])" :key="card.id" :card="card" />
      </CardsSectionBlock>
    </CardsSection>
    <!-- Innactives -->
    <CardsSection
      collapse
      title="Acciones inactivas"
      class="inactives"
      :transition-duration="500"
      :items-length="filteredCards(['paused', 'completed']).length"
    >
      <CardsSectionBlock>
        <CardSingle
          v-for="card in filteredCards(['paused', 'completed'])"
          :key="card.id"
          :card="card"
        />
      </CardsSectionBlock>
    </CardsSection>
  </DashboardLayout>
</template>

<script>
// Utilities
import { mapState } from 'vuex'
import { employeeCards } from 'Store/helpers'
// Components
import CardSingle from 'Modules/Card/CardSingle'
import CardsSection from 'Components/CardsSection'
import CardsSectionBlock from 'Components/CardsSectionBlock'
import DashboardLayout from 'Layouts/DashboardLayout'

export default {
  name: 'DashboardTeamMyCards',

  components: {
    CardSingle,
    CardsSection,
    DashboardLayout,
    CardsSectionBlock,
  },

  computed: {
    ...mapState('user', ['currentUser']),
    ...employeeCards,
    filteredCards() {
      return (status) => {
        return this.getUserCardsByStatus(status)
      }
    },
  },
}
</script>

<style scoped>
.cards-section.inactives {
  margin-bottom: 0;
}
</style>
